import request from '@/utils/request'

// 查询作品类型配置列表
export function listWorksCategoryConf(url,query) {
    return request({
        url: url+'/actuator/worksCategoryConf/list',
        method: 'get',
        params: query
    })
}

// 查询作品类型配置详细
export function getWorksCategoryConf(url,id) {
    return request({
        url: url+'/actuator/worksCategoryConf/' + id,
        method: 'get'
    })
}

// 新增作品类型配置
export function addWorksCategoryConf(url,data) {
    return request({
        url: url+'/actuator/worksCategoryConf',
        method: 'post',
        data: data
    })
}

// 修改作品类型配置
export function updateWorksCategoryConf(url,data) {
    return request({
        url: url+'/actuator/worksCategoryConf',
        method: 'put',
        data: data
    })
}

// 删除作品类型配置
export function delWorksCategoryConf(url,id) {
    return request({
        url: url+'/actuator/worksCategoryConf/' + id,
        method: 'delete'
    })
}

// 查询作品类型配置列表
export function listWorksCategoryConfPowerList(url,query) {
  return request({
    url: url+'/powerWorksCategoryConf/powerList',
    method: 'get',
    params: query
  })
}



// WEBPACK FOOTER //
// ./src/api/work/worksCategoryConf.js